export const categorias = [
  { id: 'novedades', nombre: 'Novedades', activo: true },
  { id: 'mujer', nombre: 'Mujer', activo: false },
  { id: 'hombre', nombre: 'Hombre', activo: false },
  { id: 'accesorios', nombre: 'Accesorios', activo: false },
  { id: 'ofertas', nombre: 'Ofertas', activo: false }
];

export const productos = [
  {
    id: 1,
    nombre: 'Jack Wolfskin',
    precio: '$14.990',
    imagen: 'https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/7c823a1768b692cb800e5d7c11cd1f02.jpeg',
    tallas: 'M',
    colores: '',
    categoria: 'mujer'
  },
  {
    id: 2,
    nombre: 'Chaquetón Only',
    precio: '$19.990',
    imagen: 'https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/ecfc97ef0f0c71671b1f38fb1f4b0742.jpeg',
    tallas: 'M',
    colores: '',
    categoria: 'hombre'
  },
  {
    id: 3,
    nombre: 'Tapado l&l',
    precio: '$19.990',
    imagen: 'https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/4d69ddb810cb84803f87c4e9774637b3.jpeg',
    tallas: 'M',
    colores: '',
    categoria: 'accesorios'
  },
  {
    id: 4,
    nombre: 'Tapado mujer, Zaro',
    precio: '$9.990',
    imagen: 'https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/7e9219516013b367cc7f0fa4b3ff7865.jpeg',
    tallas: 'Única',
    colores: '',
    categoria: 'mujer'
  },
  {
    id: 5,
    nombre: 'Chaleco sin mangas',
    precio: '$11.990',
    imagen: 'https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/b3789815217ba60a2828ad2ec58a799f.jpeg',
    tallas: 'S',
    colores: '',
    categoria: 'accesorios'
  },
  {
    id: 6,
    nombre: 'Chaleco sin mangas',
    precio: '$11.990',
    imagen: 'https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/abc50d13a61ce05185c398500bdcf5f7.jpeg',
    tallas: 'M',
    colores: '',
    categoria: 'hombre'
  }
];